import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Spinner from "./spinner/spinner";
import { ConferenceSalutation, ConferenceCategory } from "../constant/constant";
import { toast } from "react-toastify";
import {
  useDeleteRegistrationMutation,
  useGetAllMemberFeesQuery,
  useRegisterMemberMutation,
  useCheckMemberIdMutation,
} from "../app/services/conferenceService";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const paperPresenter = [
  { value: 1, name: "I am the main presenter in a paper presentation" },
  { value: 2, name: "I am a joint - presenter in a paper presentation" },
  { value: 3, name: "I am the main presenter in a poster presentation" },
  { value: 4, name: "I am a joint - presenter in a poster presentation" },
  {
    value: 5,
    name: "I am a participant. I am not presenting any paper / poster",
  },
];

const ConferenceForm = () => {
  const [loading, setLoading] = useState(false);
  const [registerMember] = useRegisterMemberMutation();
  const [submitted, setSubmitted] = useState(false);
  const [deleteRegistration] = useDeleteRegistrationMutation();
  const [checkmemberId, { isLoading }] = useCheckMemberIdMutation();
  const [memeberValid, setMemberValid] = useState(false);
  const [memberIderror, setMemberIdError] = useState("");
  const {
    control,
    register,
    handleSubmit,
    watch,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
      salutation: 2, // 0 - prof, 1 - Dr, 2 - Mr, 3 - Mrs, 4 - Ms
      fullName: "",
      category: "",
      otherCategory: "",
      yourDesignation: "",
      institutionName: "",
      city: "",
      state: "",
      country: "India",
      otherCountry: "",
      mobileNumber: "",
      paperPresenter: "",
      memberId: "",
      registrationPlan: "",
      dummyAmount: "",
      dummyCurrency: 0,
    },
    mode: "onChange",
  });
  const { data: planApiData } = useGetAllMemberFeesQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const planData = planApiData?.data || [];
  const handlePaymentCancelled = (id) => {
    toast.info("Payment was not completed.");
    deleteRegistration(id)
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        toast.error("Something Went Wrong" + err);
      });
  };
  const onFormSubmit = (data) => {
    // Check if member validation is required and valid
    const selectedPlan = planData.find((i) => i._id === data.registrationPlan);
    const isEltaiMember = selectedPlan?.categoryName === "ELTAI Members";
    setLoading(true);
    if (isEltaiMember && !memeberValid) {
      setLoading(false);
      setError("memberId", {
        type: "manual",
        message: "Please validate member ID",
      });
    } else {
      registerMember(data).then((res) => {
        setLoading(false);
        if (res?.data?.status) {
          var options = {
            key: process.env.REACT_APP_RAZOR_PAY_KEY_ID, // Enter the Key ID generated from the Dashboard
            amount: watch("dummyAmount"), // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            currency: watch("dummyCurrency") === 0 ? "INR" : "USD",
            config: {
              display: {
                hide: [
                  { method: "paylater" },
                  { method: "emi" },
                  { method: "wallet" },
                ],
              },
            },
            notes: {
              isConferencePayment: 1,
            },
            name: res?.data?.data?.fullName,
            description: "Membership payment",
            order_id: res?.data?.data?.purchaseData?.orderId, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            handler: function (response) {
              document.body.style.overflow = "auto";
              toast.success("Thank You for Registering with Us!");
              setSubmitted(true);
            },
            modal: {
              ondismiss: function () {
                document.body.style.overflow = "auto";
                // Handle modal dismissal (user exits without payment)
                setLoading(true);
                handlePaymentCancelled(res?.data?.data?._id); // Call your custom function
              },
            },
          };
          var rzp1 = new window.Razorpay(options);
          setLoading(false);
          rzp1.open();
          rzp1.on("payment.failed", function (response) {
            toast.error("Payment Failed Try Again");
          });
        } else {
          toast.error(res?.error?.data?.error);
        }
      });
    }
  };
  const validateMember = () => {
    clearErrors("memberId");
    setMemberIdError("");
    checkmemberId({ memberId: watch("memberId") }).then((res) => {
      if (res?.data?.status) {
        setMemberValid(true);
        setValue(
          "dummyAmount",
          planData.find((i) => i.categoryName === "ELTAI Members")?.finalAmount
        );
      } else if (res?.data?.err.message === "Invalid Member Number") {
        setMemberValid(false);
        setError("memberId", {
          type: "manual",
          message: "Invalid member ID, Please check the member ID",
        });
      } else {
        setMemberValid(true);
        setValue(
          "dummyAmount",
          planData.find((i) => i.categoryName === "Non ELTAI Members")
            ?.finalAmount
        );
        setMemberIdError("Member Plan Expired, Considered as Non ELTAI member");
      }
    });
  };
  return (
    <>
      <div className="pt-5">
        <div className="chapter-heading">
          <h2 className="text-center title-font text-light py-3 mt-1">
            ELTAI Conference Registration Form
          </h2>
        </div>
      </div>

      {loading ? (
        <Spinner />
      ) : submitted ? (
        <>
          <Box className="d-flex flex-column justify-content-center align-items-center p-md-5 p-3 overallPadding ">
            <h3 className="text-center title-font">
              Thank you for registering with us! We will confirm the receipt of your registration fee shortly and send a confirmation email to{" "}
              <span className="menus-green-color">{watch("email")}</span>.
            </h3>
          </Box>
        </>
      ) : (
        <Box
          component={"form"}
          className="d-flex flex-column align-items-center p-md-5 p-3 overallPadding "
          onSubmit={handleSubmit(onFormSubmit)}
        >
          <Grid maxWidth={"lg"} container rowSpacing={3} columnSpacing={3}>
            <Grid item lg={2} md={2} sm={2} xs={4}>
              <Controller
                control={control}
                rules={{ required: "Please select an option" }}
                name="salutation"
                render={({ field, fieldState }) => (
                  <FormControl fullWidth>
                    <InputLabel className="text-dark" id="Salutation">
                      Salutation<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Select
                      className="bg-white"
                      labelId="Salutation"
                      id="Salutation"
                      label={
                        <Typography className="text-dark">
                          Salutation
                          <span style={{ color: "red" }}>*</span>
                        </Typography>
                      }
                      value={field.value === "" ? "" : field.value}
                      variant="outlined"
                      onChange={(e) => field.onChange(e.target.value)}
                      error={!!fieldState.error}
                    >
                      {ConferenceSalutation.map((data) => (
                        <MenuItem key={data.id} value={data.id}>
                          {data.Name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item lg={4} md={4} sm={10} xs={8}>
              <TextField
                InputLabelProps={{ shrink: true }}
                id="buttonText"
                name="fullName"
                label={
                  <Typography className="text-dark">
                    Full name as it should appear on certificate{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                placeholder="Please Enter Your Full Name"
                style={{ height: "max-content" }}
                {...register("fullName", {
                  required: "Please enter full name",
                  minLength: { value: 3, message: "Please enter a valid name" },
                })}
                className="form-control"
                error={!!errors?.fullName}
                helperText={errors?.fullName?.message}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip
                        className="cursor-pointer"
                        title="No correction in names will be permitted later. Hence, ensure that your name is speltcorrectly. Do not include any salutation such as Dr/Mr/Ms/Mrs/Prof here."
                      >
                        <InfoIcon className="menus-green-color" />
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label={
                  <Typography className="text-dark">
                    Email Address<span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                InputLabelProps={{ shrink: true }}
                {...register("email", {
                  required: "Please enter a email Id",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Enter a valid email ID",
                  },
                })}
                error={!!errors?.email}
                placeholder="Enter Email ID"
                helperText={errors?.email?.message}
                fullWidth
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label={
                  <Typography className="text-dark">
                    Mobile Number (Whatsapp Number)
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                InputLabelProps={{ shrink: true }}
                {...register("mobileNumber", {
                  required: "Please enter a Mobile Number",
                  pattern: {
                    value: /^\d{10}$/,
                    message: "Mobile number must be 10 digits",
                  },
                })}
                error={!!errors?.mobileNumber}
                placeholder="Enter Mobile Number"
                helperText={errors?.mobileNumber?.message}
                fullWidth
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Controller
                control={control}
                rules={{ required: "Please select an option" }}
                name="category"
                render={({ field, fieldState }) => (
                  <FormControl fullWidth>
                    <InputLabel className="text-dark" id="Salutation">
                      Which of the following category best describes you?
                      <span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Select
                      className="bg-white"
                      labelId="category"
                      id="category"
                      label={
                        <Typography className="text-dark">
                          Which of the following category best describes you?
                          <span style={{ color: "red" }}>*</span>
                        </Typography>
                      }
                      value={field.value === "" ? "" : field.value}
                      variant="outlined"
                      onChange={(e) => field.onChange(e.target.value)}
                      error={!!fieldState.error}
                    >
                      {ConferenceCategory.map((data) => (
                        <MenuItem key={data.value} value={data.value}>
                          <Typography sx={{ whiteSpace: "normal" }}>
                            {data.name}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              />
              {errors?.category && (
                <FormHelperText
                  className="w-100"
                  error
                  style={{ textAlign: "justify" }}
                >
                  {errors?.category?.message}
                </FormHelperText>
              )}
            </Grid>
            {watch("category") === 99 && (
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  id="otherCategory"
                  label={
                    <Typography className="text-dark">
                      Other Category <span style={{ color: "red" }}>*</span>
                    </Typography>
                  }
                  placeholder="Please Enter Your Category"
                  {...register("otherCategory", {
                    required: "Please enter other category",
                    minLength: {
                      value: 3,
                      message: "Please enter a valid category",
                    },
                  })}
                  className="form-control"
                  error={!!errors?.otherCategory}
                  helperText={errors?.otherCategory?.message}
                  fullWidth
                />
              </Grid>
            )}
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                InputLabelProps={{ shrink: true }}
                id="yourDesignation"
                name="yourDesignation"
                label={
                  <Typography className="text-dark">
                    Your Designation <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                placeholder="Enter Your Designation"
                {...register("yourDesignation", {
                  required: "Please enter your designation",
                })}
                className="form-control"
                error={!!errors?.yourDesignation}
                helperText={errors?.yourDesignation?.message}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip
                        className="cursor-pointer"
                        title="As it should appear on the certificate.
                                    [If you are a student, mention your designation as
                                    Student and your course.]"
                      >
                        <InfoIcon className="menus-green-color" />
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                InputLabelProps={{ shrink: true }}
                id="institutionName"
                name="institutionName"
                label={
                  <Typography className="text-dark">
                    Name of the Institution{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                placeholder="Enter Your Institution Name"
                {...register("institutionName", {
                  required: "Please enter institution name",
                  minLength: { value: 3, message: "Please enter a valid name" },
                })}
                className="form-control"
                error={!!errors?.institutionName}
                helperText={errors?.institutionName?.message}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip
                        title="As it should appear on the certificate"
                        className="cursor-pointer"
                      >
                        <InfoIcon className="menus-green-color" />
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Controller
                control={control}
                rules={{ required: "Please select a country" }}
                name="country"
                render={({ field, fieldState }) => (
                  <FormControl fullWidth>
                    <InputLabel shrink className="text-dark" id="Salutation">
                      Country<span style={{ color: "red" }}>*</span>
                    </InputLabel>
                    <Select
                      className="bg-white"
                      labelId="country"
                      id="country"
                      label={
                        <Typography className="text-dark">
                          Country
                          <span style={{ color: "red" }}>*</span>
                        </Typography>
                      }
                      value={field.value === "" ? "" : field.value}
                      variant="outlined"
                      onChange={(e) => field.onChange(e.target.value)}
                      error={!!fieldState.error}
                      displayEmpty
                    >
                      <MenuItem value="India">India</MenuItem>
                      <MenuItem value={"Other"}>Other Country</MenuItem>
                    </Select>
                  </FormControl>
                )}
              />
              {errors?.country && (
                <FormHelperText error style={{ textAlign: "justify" }}>
                  {errors?.country?.message}
                </FormHelperText>
              )}
            </Grid>
            {watch("country") === "Other" && (
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  id="otherCategory"
                  label={
                    <Typography className="text-dark">
                      Other Country <span style={{ color: "red" }}>*</span>
                    </Typography>
                  }
                  placeholder="Please Enter Your Country"
                  {...register("otherCountry", {
                    required: "Please enter other Country",
                    minLength: {
                      value: 3,
                      message: "Please enter a valid Country",
                    },
                  })}
                  className="form-control"
                  error={!!errors?.otherCountry}
                  helperText={errors?.otherCountry?.message}
                  fullWidth
                />
              </Grid>
            )}
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                InputLabelProps={{ shrink: true }}
                id="state"
                label={
                  <Typography className="text-dark">
                    State / Province <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                placeholder="Enter a state"
                {...register("state", {
                  required: "Please enter a state",
                  minLength: {
                    value: 3,
                    message: "Please enter a valid state",
                  },
                })}
                className="form-control"
                error={!!errors?.state}
                helperText={errors?.state?.message}
                fullWidth
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                InputLabelProps={{ shrink: true }}
                id="city"
                label={
                  <Typography className="text-dark">
                    City/Town of the Institution{" "}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                }
                placeholder="Enter a city"
                style={{ height: "max-content" }}
                {...register("city", {
                  required: "Please enter a city",
                  minLength: { value: 3, message: "Please enter a valid city" },
                })}
                className="form-control"
                error={!!errors?.city}
                helperText={errors?.city?.message}
                fullWidth
              />
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              xs={12}
              className="d-flex align-items-center justify-content-end flex-column"
            >
              <div className="d-flex w-100">
                <Controller
                  control={control}
                  rules={{ required: "Please select an option" }}
                  name="paperPresenter"
                  render={({ field, fieldState }) => (
                    <FormControl fullWidth>
                      <InputLabel className="text-dark" id="Salutation">
                        Choose any one of the following statements that best
                        describes you<span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <Select
                        className="bg-white"
                        labelId="category"
                        id="category"
                        name="paperPresenter"
                        label={
                          <Typography className="text-dark">
                            Choose any one of the following statements that best
                            describes you<span style={{ color: "red" }}>*</span>
                          </Typography>
                        }
                        value={field.value === "" ? "" : field.value}
                        variant="outlined"
                        onChange={(e) => field.onChange(e.target.value)}
                        error={!!fieldState.error}
                      >
                        {paperPresenter.map((data) => (
                          <MenuItem key={data.value} value={data.value}>
                            <Typography sx={{ whiteSpace: "normal" }}>
                              {data.name}
                            </Typography>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
                <FormHelperText className="m-0">
                  <Tooltip
                    className="cursor-pointer"
                    title={
                      <>
                        Paper presenters must have submitted an abstract in the
                        abstract submission form on or before 10<sup>th</sup>{" "}
                        September 2025.
                      </>
                    }
                  >
                    <IconButton className="p-3 border rounded border-2 border-secondary-subtle cursor-pointer">
                      <InfoIcon className="menus-green-color" />
                    </IconButton>
                  </Tooltip>
                </FormHelperText>
              </div>
              {errors?.paperPresenter && (
                <FormHelperText
                  className="w-100"
                  error
                  style={{ textAlign: "justify" }}
                >
                  {errors?.paperPresenter?.message}
                </FormHelperText>
              )}
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              sm={12}
              xs={12}
              className="d-flex flex-column"
            >
              <div className="d-flex w-100">
                <Controller
                  control={control}
                  rules={{ required: "Please select an option" }}
                  name="registrationPlan"
                  render={({ field, fieldState }) => (
                    <FormControl fullWidth>
                      <InputLabel className="text-dark" id="Salutation">
                        Registration Category
                        <span style={{ color: "red" }}>*</span>
                      </InputLabel>
                      <Select
                        className="bg-white"
                        labelId="registrationPlan"
                        id="registrationPlan"
                        label={
                          <Typography className="text-dark">
                            Registration Category
                            <span style={{ color: "red" }}>*</span>
                          </Typography>
                        }
                        value={field.value === "" ? "" : field.value}
                        variant="outlined"
                        onChange={(e) => {
                          field.onChange(e.target.value);
                          setValue(
                            "dummyAmount",
                            planData.find((i) => i._id === e.target.value)
                              .finalAmount
                          );
                        }}
                        error={!!fieldState.error}
                        fullWidth
                      >
                        {planData.map((data) => (
                          <MenuItem key={data._id} value={data._id}>
                            {data?.categoryName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
                <FormHelperText className="m-0">
                  <Tooltip
                    className="cursor-pointer"
                    title={
                      <>
                        Early-bird (Till 10<sup>th</sup> October 2025) <br />
                        Regular (Between 11<sup>th</sup> October to 10
                        <sup>th</sup> November 2025) <br />
                        On-spot Registration (12<sup>th</sup> & 13<sup>th</sup>{" "}
                        November 2025)
                      </>
                    }
                  >
                    <IconButton className="p-3 border rounded border-2 border-secondary-subtle">
                      <InfoIcon className="menus-green-color" />
                    </IconButton>
                  </Tooltip>
                </FormHelperText>
              </div>
              {errors?.registrationPlan && (
                <FormHelperText
                  className="w-100"
                  error
                  style={{ textAlign: "justify" }}
                >
                  {errors?.registrationPlan?.message}
                </FormHelperText>
              )}
            </Grid>
            {planData.find((i) => i._id === watch("registrationPlan"))
              ?.categoryName === "ELTAI Members" && (
              <Grid item lg={6} md={6} sm={12} xs={12}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  id="memberId"
                  label={
                    <Typography className="text-dark">
                      ELTAI Member ID<span style={{ color: "red" }}>*</span>
                    </Typography>
                  }
                  placeholder="Enter Your ELTAI member ID"
                  style={{ height: "max-content" }}
                  {...register("memberId", {
                    required: "Please enter your member ID",
                    onChange: () => {
                      setMemberValid(false);
                      setMemberIdError("");
                      clearErrors("memberId");
                    },
                  })}
                  className="form-control"
                  error={!!errors?.memberId}
                  helperText={errors?.memberId?.message}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip
                          className="cursor-pointer"
                          title={
                            isLoading
                              ? "Validating Member Id"
                              : "Click to Validate Member Id"
                          }
                        >
                          {isLoading ? (
                            <CircularProgress size={15} />
                          ) : memeberValid ? (
                            <CheckCircleIcon className="menus-green-color" />
                          ) : (
                            <CheckCircleOutlineIcon
                              onClick={() => {
                                validateMember();
                              }}
                              className="text-danger"
                            />
                          )}
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
                {memberIderror && (
                  <FormHelperText className="text-secondary-new">
                    {memberIderror}
                  </FormHelperText>
                )}
              </Grid>
            )}
            {watch("dummyAmount") && (
              <Grid
                item
                sm={12}
                xs={12}
                className="d-flex justify-content-center  align-items-center"
              >
                <p className="bg-info w-75 p-3 text-center rounded">
                  You have to pay Rs: {watch("dummyAmount")} for registration
                </p>
              </Grid>
            )}
            <Grid item sm={12} xs={12}>
              <Typography className="mb-3">
                I am aware of the following and agree to them:
              </Typography>
              <FormControl
                error={Boolean(errors?.termsCondition)}
                component="fieldset"
              >
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={watch("termsCondition")}
                        {...register("termsCondition", {
                          required: "Please accept Terms and Conditions",
                        })}
                      />
                    }
                    label={
                      <Typography className="text-dark">
                        It will take maximum 5 working days to confirm the
                        receipt of your registration fee and email you a
                        receipt. <span style={{ color: "red" }}>*</span>
                      </Typography>
                    }
                  />
                </FormGroup>
                {errors?.termsCondition && (
                  <FormHelperText>
                    {errors.termsCondition.message}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>
            <Grid item sm={12} className="d-flex justify-content-center">
              <Button
                variant="contained"
                className="menus-color mt-5"
                type="submit"
              >
                Paynow
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
};

export default ConferenceForm;
